import { AnyAction } from "@reduxjs/toolkit";

export type ReduxAppStore = {
  dispatch: (action: AnyAction | unknown) => unknown;
  getState: () => unknown;
  subscribe: (listener: () => void) => () => void;
};

const readyListeners = new Set<() => void>();
let registeredStore: ReduxAppStore | null = null;

export function isReduxAppStore(value: unknown): value is ReduxAppStore {
  if (!value || typeof value !== "object") {
    return false;
  }

  const maybeStore = value as Partial<ReduxAppStore>;
  return (
    typeof maybeStore.dispatch === "function" &&
    typeof maybeStore.getState === "function" &&
    typeof maybeStore.subscribe === "function"
  );
}

export function registerReduxAppStore(store: ReduxAppStore) {
  registeredStore = store;

  for (const listener of readyListeners) {
    listener();
  }

  readyListeners.clear();
}

export function onReduxAppStoreReady(listener: () => void) {
  readyListeners.add(listener);

  return () => {
    readyListeners.delete(listener);
  };
}

export function resolveReduxAppStore(): ReduxAppStore | null {
  return registeredStore;
}

export function resetReduxAppStoreForTests() {
  registeredStore = null;
  readyListeners.clear();
}
